import { useFlowStore } from '@/stores/useFlowStore';
import { useNavigationStore } from '@/stores/useNavigationStore';

export function useSkipUpsellStep() {
	const flowStore = useFlowStore();
	const navStore = useNavigationStore();

	const skipEmptyChoicesAndNavigate = async (forwards: boolean = true) => {
		// Upsell groups are lazy-loaded, so ensure they are present before deciding which (empty)
		// upsell steps to skip — otherwise every group looks empty and we wrongly skip them all.
		await flowStore.loadUpsells();

		const availableSteps = forwards
			? navStore.upcomingSteps
			: navStore.passedSteps
				? navStore.passedSteps.toReversed()
				: [];
		const skipAllStep = forwards ? 'customer' : 'reservation';

		let allStepsSkipped = false;

		for (const step of availableSteps) {
			if (step.parent !== 'choices') continue;

			if (step.name === 'arrangement_hotel_choices' || step.name === 'arrangement_product_choices') {
				return await navStore.gotoStep(step.name);
			}

			let upsellChoices = flowStore.checkout.meta.upsells[step.name]?.products ?? [];

			// Lunch and diner step is a combined upsell step
			if (step.name === 'lunch_and_diner') {
				upsellChoices = [...upsellChoices, ...(flowStore.checkout.meta.upsells.hotel_rooms?.products ?? [])];
			}

			// Filter out products that are not visually available
			const availableProducts = upsellChoices.filter(
				(product) => product.is_available || !product.hide_when_not_available,
			);

			if (availableProducts.length === 0) {
				allStepsSkipped = true;
				console.log(`Skipping upsell step ${step.name}`);
			} else {
				console.log(`Going to upsell step ${step.name} = ${availableProducts.length}`);
				return await navStore.gotoStep(step.name);
			}
		}

		if (allStepsSkipped) {
			console.log(`All upsells skipped, going to ${skipAllStep}`);
			return await navStore.gotoStep(skipAllStep);
		}

		if (forwards) {
			return await navStore.gotoNextStep();
		} else {
			return await navStore.gotoPreviousStep();
		}
	};

	return { skipEmptyChoicesAndNavigate };
}
